module.exports = __webpack_public_path__ + "static/img/swiper2.c3cad9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/swiper2.png
// module id = eX+h
// module chunks = 1